import type { Property } from '@raffle/types';
import type { PropertyData } from '@raffle/ui';

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&auto=format';

type SupportedUiStatus = PropertyData['status'];

function toUiStatus(status: Property['status']): SupportedUiStatus {
  if (status === 'active' || status === 'closed' || status === 'drawn') return status;
  // Public web UI doesn't surface draft/cancelled; treat them as non-active.
  return 'closed';
}

function toImageUrls(property: Property): string[] {
  const urls = (property.images || [])
    .slice()
    .sort((a, b) => (a.isPrimary === b.isPrimary ? a.order - b.order : a.isPrimary ? -1 : 1))
    .map((img) => img.url)
    .filter((url): url is string => typeof url === 'string' && url.length > 0);

  return urls.length > 0 ? urls : [FALLBACK_IMAGE];
}

export function toPropertyData(property: Property): PropertyData {
  return {
    id: property.id,
    title: property.title,
    description: property.description,
    location: property.location,
    marketValue: property.marketValue,
    ticketPrice: property.ticketPrice,
    totalTickets: property.totalTickets,
    ticketsSold: property.ticketsSold,
    drawDate: property.drawDate,
    status: toUiStatus(property.status),
    images: toImageUrls(property),
    features: property.features,
  };
}
